module.exports = __webpack_public_path__ + "img/folderWithDocument_b.ab11d27a.svg";